import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { Navigate } from '@ngxs/router-plugin';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { SetError } from '../actions/set-error.action';
import { UnsetError } from '../actions/unset-error.action';
import { Injectable } from '@angular/core';
import { SnackBarTime } from 'app/projects/core/src/lib/constants/snack-bar';
import { HelperService } from 'app/projects/shared/src/lib/services/helper';

@State<HttpErrorResponse>({
    name: 'error',
    defaults: null,
})
@Injectable()
export class MaxBrainErrorState {
    @Selector()
    static getError(state: HttpErrorResponse): HttpErrorResponse {
        return state;
    }

    constructor(private _helperService: HelperService, private _translateService: TranslateService) {}

    @Action(SetError)
    async setError({ setState, dispatch }: StateContext<HttpErrorResponse>, { payload }: SetError): Promise<void> {
        setState(payload);

        if (payload.status >= 400 && payload.status < 500) {
            switch (payload.status) {
                case 401:
                    throw new Error('SetError action should not be called on 401 response!');
                case 404:
                    // dispatch 404 token not found
                    // else generic way to handle it
                    dispatch(new Navigate([`/errors/${payload.status}`]));
                    break;
                default:
                    let translatedErrorMessage = this._translateService.instant(`ERROR.RESPONSE.unknow_error`);

                    if (payload.error && payload.error.message) {
                        translatedErrorMessage = this._translateService.instant(`ERROR.RESPONSE.${payload.error.message}`);
                    }

                    if (payload.error && payload.error instanceof Blob) {
                        const errMessage = JSON.parse(await payload.error['text']()).message;
                        translatedErrorMessage = this._translateService.instant(`ERROR.RESPONSE.${errMessage}`);
                    }

                    this._helperService.showSnackBarMessage(translatedErrorMessage, 'OK', SnackBarTime.medium);
                    break;
            }
        } else {
            dispatch(new Navigate([`/errors/${payload.status}`]));
        }
    }

    @Action(UnsetError)
    unsetError({ setState }: StateContext<HttpErrorResponse>): void {
        setState(null);
    }
}
